import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import {
  AUTH_LOGOUT,
  INITIAL_STATE,
  OWNERS_UPDATE,
  APPLICATION_WIPE_DATA,
  OWNERS_DELETE,
} from '../actions';

const initialState = {
  items: {},
  lastUpdated: null,
};

const setInitialState = (state, { owners = initialState }) =>
  update(state, {
    $merge: owners,
  });

const updateOwners = (state, { owners }) =>
  update(state, {
    items: { $set: owners },
    lastUpdated: { $set: Date.now() },
  });

const deleteOwner = (state, { id }) =>
  update(state, {
    items: {
      $apply: function (obj) {
        delete obj[id];
        return obj;
      },
    },
    lastUpdated: { $set: Date.now() },
  });

const cleanData = () => {
  return initialState;
};

const actionsRepo = {
  [INITIAL_STATE]: setInitialState,
  [OWNERS_UPDATE]: updateOwners,
  [OWNERS_DELETE]: deleteOwner,
  [APPLICATION_WIPE_DATA]: cleanData,
  [AUTH_LOGOUT]: cleanData,
};

export default createReducer({ initialState, actionsRepo });
